import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ParseHelper } from '../../../parse.helper';
import { extractSavedSearchRuleCombinationIds, restoreSavedSearchCombineRulesValue } from '../../../../../misc/saved-searches/helpers/prepare-saved-search-rule-values.helper';
import { create, all } from 'mathjs';
@Component({
  selector: 'app-saved-search-added-rules-table',
  templateUrl: './saved-search-added-rules-table.component.html',
  styleUrls: ['./saved-search-added-rules-table.component.scss']
})
export class SavedSearchAddedRulesTableComponent implements OnInit, OnChanges {

    @Input() ruleData: SavedSearchNS.IRuleList[] = [];
    @Input() isDisabled: boolean = false;
    @Input() isCombinational: boolean = false;
    @Input() ruleCombination: string = "";
    @Input() editedRuleData: SavedSearchNS.IRuleList = null;
    @Input() showHideDefaultData: boolean = false;
    @Input() isMainModule: boolean = false;

    @Output() editRuleChange = new EventEmitter<any>();
    @Output() updateRuleChoice = new EventEmitter<{ruleIndex: number, choice: SavedSearchNS.IChoice}>();
    @Output() saveRuleCombination = new EventEmitter<{isCombinational: boolean, ruleCombination: string}>();
    @Output() removeRuleChange = new EventEmitter<any>();

    choicesDD: SavedSearchNS.IChoice[] = [
        { id: 1, name: "And" },
        { id: 2, name: "Or" },
    ];

    selectedCombineChoice: SavedSearchNS.IChoice = null;
    combinedRules: SavedSearchNS.ICombineRuleList[] = [];

    isEditCombineRule: boolean = false;
    combinedRulesValue: string = "";
    combinedRulesValueEdit: string = "";
    combineRulesErrorMsg: string = "";
    mathJs = create(all);
    checkArray = Array;

    constructor() { }

    ngOnInit(): void {
        this.ruleData[0].ruleNo="#1#"
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['ruleData'] && changes['ruleData'].currentValue){
            this.ruleData = changes['ruleData'].currentValue;
            this.checkRulesCombination();
        }

        if(changes['editedRuleData'] && changes['editedRuleData'].currentValue){
            this.editedRuleData = changes['editedRuleData'].currentValue;
            this.checkRulesCombination();
        }

        if(changes['isDisabled'] && (changes['isDisabled'].currentValue==false || changes['isDisabled'].currentValue==true)){
            this.isDisabled = changes['isDisabled'].currentValue;
        }

        if(changes['isCombinational'] && changes['isCombinational'].currentValue){
            this.isCombinational = changes['isCombinational'].currentValue;
        }

        if(changes['ruleCombination'] && changes['ruleCombination'].currentValue){
            this.ruleCombination = changes['ruleCombination'].currentValue;
            this.restoreCombineRulesValue();
        }
    }

    editRule(rule: any, index){
        this.editRuleChange.emit({
            rule: rule,
            index: index
        })
    }

    removeRule(rule: any, index: number){
        this.removeRuleChange.emit({
            rule: rule,
            index: index
        });

        setTimeout(()=>{
            this.checkRulesCombination();
        }, 100)
    }

    addCombineRules(){
        this.regenerateRuleCombination();
    }

    editCombineRule(){
        this.isEditCombineRule = true;
        this.combinedRulesValueEdit = ParseHelper.DeepCopy(this.combinedRulesValue);
    }

    saveCombineRules(){
        const combinedRulesValue = this.combinedRulesValueEdit.toLowerCase().trim();
        this.combineRulesErrorMsg = "";

        if(!combinedRulesValue){
            this.combineRulesErrorMsg = "Enter combination rules, or use clear button";
            return;
        }else if(!this.isValidExpression(combinedRulesValue)){
            this.combineRulesErrorMsg = "Expression not valid, please check brackets/operators";
            return;
        }else if(!this.isCombinedRulesSequential(combinedRulesValue)){
            this.combineRulesErrorMsg = "Combination rules sequence not correct";
            return;
        }

        this.combinedRulesValue = this.combinedRulesValueEdit.toLowerCase().trim();
        this.addClosingBrackets();
        this.generateSaveRuleCombination();
        this.isEditCombineRule = false;
    }

    addClosingBrackets(){
        this.combinedRulesValue = this.combinedRulesValue.trim();
        if(!this.combinedRulesValue.startsWith('(') || !this.combinedRulesValue.endsWith(')')){
            this.combinedRulesValue = `(${this.combinedRulesValue})`;
        }
    }

    replaceOperators(expression: string): string {
        const whitespaceRegex = /\s/g;
        // Use replace() method to remove all whitespaces from the expression
        expression = expression.replace(whitespaceRegex, '');
        // Replace "and" with "+"
        let modifiedExpression = expression.replace(/and/g, '+');
        // Replace "or" with "+"
        modifiedExpression = modifiedExpression.replace(/or/g, '+');
        return modifiedExpression;
    }

    isValidExpression(expression: string): boolean {

        expression = this.replaceOperators(expression);

        if(expression.includes('++')){
            return false;
        }

        try {
            this.mathJs.parse(expression).compile().evaluate();
            return true;
        } catch (error) {
            return false;
        }

        // try {
        //     // Attempt to evaluate the expression
        //     eval(expression);
        //     return true;
        // } catch (error) {
        //     // If an error occurs during evaluation, the expression is invalid
        //     return false;
        // }
    }

    restoreCombineRulesValue(){
        if(this.isCombinational && this.ruleCombination){
            let combinedRulesValue = ParseHelper.DeepCopy(this.ruleCombination);
            this.combinedRulesValue = restoreSavedSearchCombineRulesValue(combinedRulesValue, this.ruleData);
        }
    }

    checkRulesCombination(){
        if(this.ruleCombination && this.isCombinational){
            this.checkRulesCombinationOperators();
            const combinedRulesValueWithIds = extractSavedSearchRuleCombinationIds(this.ruleCombination);
            const deletedRules: string[] = [];

            combinedRulesValueWithIds.map(ruleNo=>{
                const exist = this.ruleData.find(rule=> rule.ruleNo==ruleNo);

                if(!exist){deletedRules.push(ruleNo)}
            });

            if(deletedRules?.length>0){
                this.checkDeletedRules(deletedRules);
            }

            const newRules = this.ruleData.filter(rule=> !combinedRulesValueWithIds.includes(rule?.ruleNo));

            newRules.map(rule=>{

                const textToAdd = ` ${(rule.choice?.name||'and')} ${rule.ruleNo}`;

                if(this.combinedRulesValue.startsWith('(') && this.combinedRulesValue.endsWith(')')){
                    const lastClosingBracketIndex = this.ruleCombination.lastIndexOf(')');
                    this.ruleCombination = this.ruleCombination.slice(0, lastClosingBracketIndex) + textToAdd + this.ruleCombination.slice(lastClosingBracketIndex);
                }else{
                    this.ruleCombination = this.ruleCombination + textToAdd;
                }

                this.ruleCombination = this.ruleCombination.toLowerCase();
            });

            this.ruleCombination = this.beutifyConbineRulesValue(this.ruleCombination);

            this.saveRuleCombination.emit({
                isCombinational: true,
                ruleCombination: this.ruleCombination
            });

        }else if(this.isCombinational){
            this.regenerateRuleCombination();
        }

        this.cancelCombineRules();
    }

    checkDeletedRules(deletedRules: string[]){
        deletedRules.map(ruleNo=>{
            let splitedRule = this.ruleCombination.split(ruleNo);

            if(splitedRule?.length>1){
                let beforeText = splitedRule[0];
                let afterText = splitedRule[1];

                const andOrRegex = /\band\b|\bor\b/g;

                // Use exec() method to find the first match of the regular expression in the expression
                const match = andOrRegex.exec(afterText);

                if (match !== null) {
                    const newOperator =  match[0];
                    beforeText = this.findLastAndOr(beforeText, newOperator);
                    afterText = afterText.replace(newOperator, '').trim();
                }else{
                    beforeText = this.findLastAndOr(beforeText, '', true);
                }

                this.ruleCombination = beforeText + afterText;
            }
        });
    }

    checkRulesCombinationOperators(updateChoice: boolean = false){
        if(this.ruleCombination && this.isCombinational){

            const combinedRulesValueWithIds = extractSavedSearchRuleCombinationIds(this.ruleCombination);

            combinedRulesValueWithIds.map((ruleNo, index)=>{
                const addedRule = this.ruleData.find(rule=> rule.ruleNo==ruleNo);
                let splitedRule = this.ruleCombination.split(ruleNo);

                if(index==0 && splitedRule?.length>1){
                    let beforeText = splitedRule[0];
                    const afterText = splitedRule[1];

                    beforeText = this.findLastAndOr(beforeText,"", true);
                    this.ruleCombination = beforeText+ruleNo+afterText;
                }else if(splitedRule?.length>1 && addedRule?.choice?.name){
                    let beforeText = splitedRule[0];
                    const afterText = splitedRule[1];

                    if(updateChoice){
                        this.updateChoiceFromCombineRules(beforeText,addedRule);
                    }else{
                        beforeText = this.findLastAndOr(beforeText,addedRule?.choice?.name);
                    }

                    this.ruleCombination = beforeText+ruleNo+afterText;
                }
            })
        }
    }

    findLastAndOr(expression: string, newOperator: string, removeLastOperator: boolean = false) {
        newOperator = newOperator ? newOperator.toLowerCase() : "and";
        // Define a regular expression to match 'and' or 'or' operators from right to left
        const andOrRegex = /(?:and|or)(?=[^and]*$)/g;

        // Use exec() method to find the last match of the regular expression in the expression
        let match;
        let lastAndOrIndex = -1;
        while ((match = andOrRegex.exec(expression)) !== null) {
            // Store the index of the last match found
            lastAndOrIndex = match.index;
        }

        if (lastAndOrIndex !== -1) {
            // Get the text before the last 'and' or 'or' occurrence
            const beforeText = expression.substring(0, lastAndOrIndex);
            // Get the substring from the index of the last 'and' or 'or' occurrence until the end of the expression
            let afterText = expression.substring(lastAndOrIndex);

            if(removeLastOperator){
                if(afterText.startsWith('or')){
                    afterText = afterText.replace('or', "");
                }else if(afterText.startsWith('and')){
                    afterText = afterText.replace('and', "");
                }
            }else if(!afterText.startsWith(newOperator)){
                const replaceOperator = newOperator;
                if(newOperator=='and'){
                    afterText = afterText.replace('or', replaceOperator);
                }else{
                    afterText = afterText.replace('and', replaceOperator);
                }
            }

            return beforeText + afterText;
        }else{
            return expression;
        }
    }

    updateChoiceFromCombineRules(expression: string, addedRule: SavedSearchNS.IRuleList) {
        const andOrRegex = /(?:and|or)(?=[^and]*$)/g;
        const ruleIndex = this.ruleData.findIndex(rule=> rule.ruleNo==addedRule.ruleNo);
        // Use exec() method to find the last match of the regular expression in the expression
        let match;
        let lastAndOrIndex = -1;
        while ((match = andOrRegex.exec(expression)) !== null) {
            // Store the index of the last match found
            lastAndOrIndex = match.index;
        }

        if (lastAndOrIndex !== -1 && ruleIndex>0) {
            // Get the substring from the index of the last 'and' or 'or' occurrence until the end of the expression
            let afterText = expression.substring(lastAndOrIndex);

            let choice = null;
            if(afterText.startsWith('or') && addedRule?.choice?.name?.toLowerCase()!='or'){
                choice = this.choicesDD[1];
            }else if(afterText.startsWith('and') && addedRule?.choice?.name?.toLowerCase()!='and'){
                choice = this.choicesDD[0];
            }

            if(choice){
                this.ruleData[ruleIndex].choice = choice;
                this.updateRuleChoice.emit({
                    ruleIndex: ruleIndex,
                    choice: choice
                });
            }
        }
    }

    beutifyConbineRulesValue(ruleCombination: string){
        const whitespaceRegex = /\s/g;
        // Use replace() method to remove all whitespaces from the expression
        ruleCombination = ruleCombination.replace(whitespaceRegex, '');
        // Define a regular expression to match parentheses "()"
        const parenthesesRegex = /\(\)/g;

        // Use replace() method to remove all matches of parentheses from the expression
        ruleCombination = ruleCombination.replace(parenthesesRegex, '');
        ruleCombination = ruleCombination.replace(parenthesesRegex, '');
        ruleCombination = ruleCombination.replace(parenthesesRegex, '');
        // Replace "and" with "+"
        let modifiedExpression = ruleCombination.replace(/and/g, ' and ');
        // Replace "or" with "+"
        modifiedExpression = modifiedExpression.replace(/or/g, ' or ');
        return modifiedExpression;
    }

    regenerateRuleCombination(){
        let combinedRulesValue = "";
        this.ruleData.map((rule, index)=>{
            combinedRulesValue = combinedRulesValue + `${index>0 ? ' '+(rule.choice?.name||'and ') : ''} ${index+1}`
        });

        this.combinedRulesValue = combinedRulesValue.toLowerCase();
        this.addClosingBrackets();
        this.generateSaveRuleCombination();
    }

    generateSaveRuleCombination(){
        const combinedIndexList = this.extractNumbers(this.combinedRulesValue);
        let combinedRulesValueWithIds = this.addHashAroundNumbers(this.combinedRulesValue,'*');

        combinedIndexList.map(ci=>{
           const ruleNo = this.ruleData[(ci-1)]?.ruleNo||"#NoRuleFound#";
           combinedRulesValueWithIds = combinedRulesValueWithIds.replace(`*${ci}*`, ruleNo);
        });

        this.ruleCombination = combinedRulesValueWithIds;
        this.checkRulesCombinationOperators(true);
        this.ruleCombination = this.beutifyConbineRulesValue(this.ruleCombination);
        this.combineRulesErrorMsg = "";
        this.isEditCombineRule = false;
        this.restoreCombineRulesValue();
        this.saveRuleCombination.emit({
            isCombinational: true,
            ruleCombination: this.ruleCombination
        });
    }

    addHashAroundNumbers(input: string, hash: string = '#'): string {
        return input.replace(/\d+/g, (match) => `${hash}${match}${hash}`);
    }

    isCombinedRulesSequential(combinedRulesValue): boolean {
        const numbers: number[] = this.extractNumbers(combinedRulesValue);

        if(this.ruleData?.length!=numbers?.length){
            return false;
        }

        for (let i = 0; i < numbers.length - 1; i++) {
            if (numbers[i] + 1 !== numbers[i + 1]) {
                return false;
            }
        }
        return true;
    }

    extractNumbers(input: string): number[] {
        const numbers: number[] = [];
        const numberRegex = /\d+/g;
        let match;

        while ((match = numberRegex.exec(input)) !== null) {
            numbers.push(parseInt(match[0]));
        }

        return numbers;
    }

    cancelCombineRules(){
        this.combineRulesErrorMsg = "";
        this.isEditCombineRule = false;
    }

    clearCombineRules(){
        this.combineRulesErrorMsg = "";
        this.combinedRulesValue = "";
        this.saveRuleCombination.emit({
            isCombinational: false,
            ruleCombination: ""
        });
        this.cancelCombineRules();
    }

}
